
export const COUNTRIES = [
    'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan',
    'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi',
    'Cabo Verde', 'Cambodia', 'Cameroon', 'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo, Democratic Republic of the', 'Congo, Republic of the', 'Costa Rica', 'Cote d\'Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic',
    'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic',
    'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia',
    'Fiji', 'Finland', 'France',
    'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana',
    'Haiti', 'Honduras', 'Hungary',
    'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy',
    'Jamaica', 'Japan', 'Jordan',
    'Kazakhstan', 'Kenya', 'Kiribati', 'Kosovo', 'Kuwait', 'Kyrgyzstan',
    'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg',
    'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar',
    'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway',
    'Oman',
    'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal',
    'Qatar',
    'Romania', 'Russia', 'Rwanda',
    'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria',
    'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu',
    'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan',
    'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam',
    'Yemen',
    'Zambia', 'Zimbabwe'
];

export const COUNTRY_CODES = {
    'Afghanistan': { iso2: 'AF', iso3: 'AFG' },
    'Albania': { iso2: 'AL', iso3: 'ALB' },
    'Algeria': { iso2: 'DZ', iso3: 'DZA' },
    'Andorra': { iso2: 'AD', iso3: 'AND' },
    'Angola': { iso2: 'AO', iso3: 'AGO' },
    'Antigua and Barbuda': { iso2: 'AG', iso3: 'ATG' },
    'Argentina': { iso2: 'AR', iso3: 'ARG' },
    'Armenia': { iso2: 'AM', iso3: 'ARM' },
    'Australia': { iso2: 'AU', iso3: 'AUS' },
    'Austria': { iso2: 'AT', iso3: 'AUT' },
    'Azerbaijan': { iso2: 'AZ', iso3: 'AZE' },
    'Bahamas': { iso2: 'BS', iso3: 'BHS' },
    'Bahrain': { iso2: 'BH', iso3: 'BHR' },
    'Bangladesh': { iso2: 'BD', iso3: 'BGD' },
    'Barbados': { iso2: 'BB', iso3: 'BRB' },
    'Belarus': { iso2: 'BY', iso3: 'BLR' },
    'Belgium': { iso2: 'BE', iso3: 'BEL' },
    'Belize': { iso2: 'BZ', iso3: 'BLZ' },
    'Benin': { iso2: 'BJ', iso3: 'BEN' },
    'Bhutan': { iso2: 'BT', iso3: 'BTN' },
    'Bolivia': { iso2: 'BO', iso3: 'BOL' },
    'Bosnia and Herzegovina': { iso2: 'BA', iso3: 'BIH' },
    'Botswana': { iso2: 'BW', iso3: 'BWA' },
    'Brazil': { iso2: 'BR', iso3: 'BRA' },
    'Brunei': { iso2: 'BN', iso3: 'BRN' },
    'Bulgaria': { iso2: 'BG', iso3: 'BGR' },
    'Burkina Faso': { iso2: 'BF', iso3: 'BFA' },
    'Burundi': { iso2: 'BI', iso3: 'BDI' },
    'Cabo Verde': { iso2: 'CV', iso3: 'CPV' },
    'Cambodia': { iso2: 'KH', iso3: 'KHM' },
    'Cameroon': { iso2: 'CM', iso3: 'CMR' },
    'Canada': { iso2: 'CA', iso3: 'CAN' },
    'Central African Republic': { iso2: 'CF', iso3: 'CAF' },
    'Chad': { iso2: 'TD', iso3: 'TCD' },
    'Chile': { iso2: 'CL', iso3: 'CHL' },
    'China': { iso2: 'CN', iso3: 'CHN' },
    'Colombia': { iso2: 'CO', iso3: 'COL' },
    'Comoros': { iso2: 'KM', iso3: 'COM' },
    'Congo, Democratic Republic of the': { iso2: 'CD', iso3: 'COD' },
    'Congo, Republic of the': { iso2: 'CG', iso3: 'COG' },
    'Costa Rica': { iso2: 'CR', iso3: 'CRI' },
    'Cote d\'Ivoire': { iso2: 'CI', iso3: 'CIV' },
    'Croatia': { iso2: 'HR', iso3: 'HRV' },
    'Cuba': { iso2: 'CU', iso3: 'CUB' },
    'Cyprus': { iso2: 'CY', iso3: 'CYP' },
    'Czech Republic': { iso2: 'CZ', iso3: 'CZE' },
    'Denmark': { iso2: 'DK', iso3: 'DNK' },
    'Djibouti': { iso2: 'DJ', iso3: 'DJI' },
    'Dominica': { iso2: 'DM', iso3: 'DMA' },
    'Dominican Republic': { iso2: 'DO', iso3: 'DOM' },
    'Ecuador': { iso2: 'EC', iso3: 'ECU' },
    'Egypt': { iso2: 'EG', iso3: 'EGY' },
    'El Salvador': { iso2: 'SV', iso3: 'SLV' },
    'Equatorial Guinea': { iso2: 'GQ', iso3: 'GNQ' },
    'Eritrea': { iso2: 'ER', iso3: 'ERI' },
    'Estonia': { iso2: 'EE', iso3: 'EST' },
    'Eswatini': { iso2: 'SZ', iso3: 'SWZ' },
    'Ethiopia': { iso2: 'ET', iso3: 'ETH' },
    'Fiji': { iso2: 'FJ', iso3: 'FJI' },
    'Finland': { iso2: 'FI', iso3: 'FIN' },
    'France': { iso2: 'FR', iso3: 'FRA' },
    'Gabon': { iso2: 'GA', iso3: 'GAB' },
    'Gambia': { iso2: 'GM', iso3: 'GMB' },
    'Georgia': { iso2: 'GE', iso3: 'GEO' },
    'Germany': { iso2: 'DE', iso3: 'DEU' },
    'Ghana': { iso2: 'GH', iso3: 'GHA' },
    'Greece': { iso2: 'GR', iso3: 'GRC' },
    'Greenland': { iso2: 'GL', iso3: 'GRL' },
    'Grenada': { iso2: 'GD', iso3: 'GRD' },
    'Guatemala': { iso2: 'GT', iso3: 'GTM' },
    'Guinea': { iso2: 'GN', iso3: 'GIN' },
    'Guinea-Bissau': { iso2: 'GW', iso3: 'GNB' },
    'Guyana': { iso2: 'GY', iso3: 'GUY' },
    'Haiti': { iso2: 'HT', iso3: 'HTI' },
    'Honduras': { iso2: 'HN', iso3: 'HND' },
    'Hungary': { iso2: 'HU', iso3: 'HUN' },
    'Iceland': { iso2: 'IS', iso3: 'ISL' },
    'India': { iso2: 'IN', iso3: 'IND' },
    'Indonesia': { iso2: 'ID', iso3: 'IDN' },
    'Iran': { iso2: 'IR', iso3: 'IRN' },
    'Iraq': { iso2: 'IQ', iso3: 'IRQ' },
    'Ireland': { iso2: 'IE', iso3: 'IRL' },
    'Israel': { iso2: 'IL', iso3: 'ISR' },
    'Italy': { iso2: 'IT', iso3: 'ITA' },
    'Jamaica': { iso2: 'JM', iso3: 'JAM' },
    'Japan': { iso2: 'JP', iso3: 'JPN' },
    'Jordan': { iso2: 'JO', iso3: 'JOR' },
    'Kazakhstan': { iso2: 'KZ', iso3: 'KAZ' },
    'Kenya': { iso2: 'KE', iso3: 'KEN' },
    'Kiribati': { iso2: 'KI', iso3: 'KIR' },
    'Kosovo': { iso2: 'XK', iso3: 'XKX' },
    'Kuwait': { iso2: 'KW', iso3: 'KWT' },
    'Kyrgyzstan': { iso2: 'KG', iso3: 'KGZ' },
    'Laos': { iso2: 'LA', iso3: 'LAO' },
    'Latvia': { iso2: 'LV', iso3: 'LVA' },
    'Lebanon': { iso2: 'LB', iso3: 'LBN' },
    'Lesotho': { iso2: 'LS', iso3: 'LSO' },
    'Liberia': { iso2: 'LR', iso3: 'LBR' },
    'Libya': { iso2: 'LY', iso3: 'LBY' },
    'Liechtenstein': { iso2: 'LI', iso3: 'LIE' },
    'Lithuania': { iso2: 'LT', iso3: 'LTU' },
    'Luxembourg': { iso2: 'LU', iso3: 'LUX' },
    'Madagascar': { iso2: 'MG', iso3: 'MDG' },
    'Malawi': { iso2: 'MW', iso3: 'MWI' },
    'Malaysia': { iso2: 'MY', iso3: 'MYS' },
    'Maldives': { iso2: 'MV', iso3: 'MDV' },
    'Mali': { iso2: 'ML', iso3: 'MLI' },
    'Malta': { iso2: 'MT', iso3: 'MLT' },
    'Marshall Islands': { iso2: 'MH', iso3: 'MHL' },
    'Mauritania': { iso2: 'MR', iso3: 'MRT' },
    'Mauritius': { iso2: 'MU', iso3: 'MUS' },
    'Mexico': { iso2: 'MX', iso3: 'MEX' },
    'Micronesia': { iso2: 'FM', iso3: 'FSM' },
    'Moldova': { iso2: 'MD', iso3: 'MDA' },
    'Monaco': { iso2: 'MC', iso3: 'MCO' },
    'Mongolia': { iso2: 'MN', iso3: 'MNG' },
    'Montenegro': { iso2: 'ME', iso3: 'MNE' },
    'Morocco': { iso2: 'MA', iso3: 'MAR' },
    'Mozambique': { iso2: 'MZ', iso3: 'MOZ' },
    'Myanmar': { iso2: 'MM', iso3: 'MMR' },
    'Namibia': { iso2: 'NA', iso3: 'NAM' },
    'Nauru': { iso2: 'NR', iso3: 'NRU' },
    'Nepal': { iso2: 'NP', iso3: 'NPL' },
    'Netherlands': { iso2: 'NL', iso3: 'NLD' },
    'New Zealand': { iso2: 'NZ', iso3: 'NZL' },
    'Nicaragua': { iso2: 'NI', iso3: 'NIC' },
    'Niger': { iso2: 'NE', iso3: 'NER' },
    'Nigeria': { iso2: 'NG', iso3: 'NGA' },
    'North Korea': { iso2: 'KP', iso3: 'PRK' },
    'North Macedonia': { iso2: 'MK', iso3: 'MKD' },
    'Norway': { iso2: 'NO', iso3: 'NOR' },
    'Oman': { iso2: 'OM', iso3: 'OMN' },
    'Pakistan': { iso2: 'PK', iso3: 'PAK' },
    'Palau': { iso2: 'PW', iso3: 'PLW' },
    'Palestine': { iso2: 'PS', iso3: 'PSE' },
    'Panama': { iso2: 'PA', iso3: 'PAN' },
    'Papua New Guinea': { iso2: 'PG', iso3: 'PNG' },
    'Paraguay': { iso2: 'PY', iso3: 'PRY' },
    'Peru': { iso2: 'PE', iso3: 'PER' },
    'Philippines': { iso2: 'PH', iso3: 'PHL' },
    'Poland': { iso2: 'PL', iso3: 'POL' },
    'Portugal': { iso2: 'PT', iso3: 'PRT' },
    'Qatar': { iso2: 'QA', iso3: 'QAT' },
    'Romania': { iso2: 'RO', iso3: 'ROU' },
    'Russia': { iso2: 'RU', iso3: 'RUS' },
    'Rwanda': { iso2: 'RW', iso3: 'RWA' },
    'Saint Kitts and Nevis': { iso2: 'KN', iso3: 'KNA' },
    'Saint Lucia': { iso2: 'LC', iso3: 'LCA' },
    'Saint Vincent and the Grenadines': { iso2: 'VC', iso3: 'VCT' },
    'Samoa': { iso2: 'WS', iso3: 'WSM' },
    'San Marino': { iso2: 'SM', iso3: 'SMR' },
    'Sao Tome and Principe': { iso2: 'ST', iso3: 'STP' },
    'Saudi Arabia': { iso2: 'SA', iso3: 'SAU' },
    'Senegal': { iso2: 'SN', iso3: 'SEN' },
    'Serbia': { iso2: 'RS', iso3: 'SRB' },
    'Seychelles': { iso2: 'SC', iso3: 'SYC' },
    'Sierra Leone': { iso2: 'SL', iso3: 'SLE' },
    'Singapore': { iso2: 'SG', iso3: 'SGP' },
    'Slovakia': { iso2: 'SK', iso3: 'SVK' },
    'Slovenia': { iso2: 'SI', iso3: 'SVN' },
    'Solomon Islands': { iso2: 'SB', iso3: 'SLB' },
    'Somalia': { iso2: 'SO', iso3: 'SOM' },
    'South Africa': { iso2: 'ZA', iso3: 'ZAF' },
    'South Korea': { iso2: 'KR', iso3: 'KOR' },
    'South Sudan': { iso2: 'SS', iso3: 'SSD' },
    'Spain': { iso2: 'ES', iso3: 'ESP' },
    'Sri Lanka': { iso2: 'LK', iso3: 'LKA' },
    'Sudan': { iso2: 'SD', iso3: 'SDN' },
    'Suriname': { iso2: 'SR', iso3: 'SUR' },
    'Sweden': { iso2: 'SE', iso3: 'SWE' },
    'Switzerland': { iso2: 'CH', iso3: 'CHE' },
    'Syria': { iso2: 'SY', iso3: 'SYR' },
    'Taiwan': { iso2: 'TW', iso3: 'TWN' },
    'Tajikistan': { iso2: 'TJ', iso3: 'TJK' },
    'Tanzania': { iso2: 'TZ', iso3: 'TZA' },
    'Thailand': { iso2: 'TH', iso3: 'THA' },
    'Timor-Leste': { iso2: 'TL', iso3: 'TLS' },
    'Togo': { iso2: 'TG', iso3: 'TGO' },
    'Tonga': { iso2: 'TO', iso3: 'TON' },
    'Trinidad and Tobago': { iso2: 'TT', iso3: 'TTO' },
    'Tunisia': { iso2: 'TN', iso3: 'TUN' },
    'Turkey': { iso2: 'TR', iso3: 'TUR' },
    'Turkmenistan': { iso2: 'TM', iso3: 'TKM' },
    'Tuvalu': { iso2: 'TV', iso3: 'TUV' },
    'Uganda': { iso2: 'UG', iso3: 'UGA' },
    'Ukraine': { iso2: 'UA', iso3: 'UKR' },
    'United Arab Emirates': { iso2: 'AE', iso3: 'ARE' },
    'United Kingdom': { iso2: 'GB', iso3: 'GBR' },
    'United States': { iso2: 'US', iso3: 'USA' },
    'Uruguay': { iso2: 'UY', iso3: 'URY' },
    'Uzbekistan': { iso2: 'UZ', iso3: 'UZB' },
    'Vanuatu': { iso2: 'VU', iso3: 'VUT' },
    'Vatican City': { iso2: 'VA', iso3: 'VAT' },
    'Venezuela': { iso2: 'VE', iso3: 'VEN' },
    'Vietnam': { iso2: 'VN', iso3: 'VNM' },
    'Yemen': { iso2: 'YE', iso3: 'YEM' },
    'Zambia': { iso2: 'ZM', iso3: 'ZMB' },
    'Zimbabwe': { iso2: 'ZW', iso3: 'ZWE' }
};
